// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SurveyRouteImport } from './routes/survey'
import { Route as DemographicsRouteImport } from './routes/demographics'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReportIdRouteImport } from './routes/report.$id'
import { Route as ProfileSlugRouteImport } from './routes/profile.$slug'
import { Route as DevEmailPreviewRouteImport } from './routes/dev.email-preview'
import { Route as ReportSelectIdRouteImport } from './routes/report.select.$id'
import { Route as ReportBothIdRouteImport } from './routes/report.both.$id'

const SurveyRoute = SurveyRouteImport.update({
            id: '/survey',path: '/survey',getParentRoute: () => rootRouteImport
          })
const DemographicsRoute = DemographicsRouteImport.update({
            id: '/demographics',path: '/demographics',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ReportIdRoute = ReportIdRouteImport.update({
            id: '/report/$id',path: '/report/$id',getParentRoute: () => rootRouteImport
          })
const ProfileSlugRoute = ProfileSlugRouteImport.update({
            id: '/profile/$slug',path: '/profile/$slug',getParentRoute: () => rootRouteImport
          })
const DevEmailPreviewRoute = DevEmailPreviewRouteImport.update({
            id: '/dev/email-preview',path: '/dev/email-preview',getParentRoute: () => rootRouteImport
          })
const ReportSelectIdRoute = ReportSelectIdRouteImport.update({
            id: '/report/select/$id',path: '/report/select/$id',getParentRoute: () => rootRouteImport
          })
const ReportBothIdRoute = ReportBothIdRouteImport.update({
            id: '/report/both/$id',path: '/report/both/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,DemographicsRoute: DemographicsRoute,SurveyRoute: SurveyRoute,DevEmailPreviewRoute: DevEmailPreviewRoute,ProfileSlugRoute: ProfileSlugRoute,ReportIdRoute: ReportIdRoute,ReportBothIdRoute: ReportBothIdRoute,ReportSelectIdRoute: ReportSelectIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)